import { CategoryDisplayName } from '@oxappsec/ox-consolidated-categories';
import { FilterTypeToFilter } from '../../../common/filters-utils/filters-utils';
import TopIssuesStore, {
  initialTopIssuesStoreValues,
} from '../stores/top-issues-store';
import { RawIssue } from '../../common/types/raw-issue-type';
import { convertIssue } from '../../common/utils/convert-issue-utils';

export const setStoreTopIssues = (rawIssues: RawIssue[]) => {
  TopIssuesStore.topIssues = [...rawIssues.map(convertIssue)].slice(0, 5);
};

export const setTopIssuesCategory = (topCategoriesIssues: RawIssue[]) => {
  TopIssuesStore.topIssuesCategory = [
    ...topCategoriesIssues.map(convertIssue),
  ].slice(0, 5);
};

export const setCategoriesFilters = (categories: CategoryDisplayName[]) => {
  TopIssuesStore.categoriesFilters = categories;
};

export const setTotalIssues = (totalIssues: number) => {
  TopIssuesStore.totalIssues = totalIssues;
};

export const setFilterBy = (
  filterType?: FilterTypeToFilter,
  filterBy?: string,
) => {
  if (filterBy && filterType) {
    TopIssuesStore.filterBy[filterType] = [filterBy];
  } else {
    TopIssuesStore.filterBy = {};
  }
};

export const clearStore = () => {
  Object.keys(initialTopIssuesStoreValues).forEach(key => {
    TopIssuesStore[key] = initialTopIssuesStoreValues[key];
  });
};
